import { render, staticRenderFns } from "./detailsStatus.vue?vue&type=template&id=620c975f&scoped=true"
import script from "./detailsStatus.vue?vue&type=script&lang=js"
export * from "./detailsStatus.vue?vue&type=script&lang=js"
import style0 from "./detailsStatus.vue?vue&type=style&index=0&id=620c975f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c975f",
  null
  
)

export default component.exports